module.exports = __webpack_public_path__ + "img/OPRanchingLogo.d8a15e75.png";